import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { ConsentCtx } from './ConsentContext.js';
import { defaultStrings } from './strings.js';
export function ConsentProvider({ core, strings = defaultStrings, dialogId = 'cmp-dialog', children, }) {
    const [state, setState] = useState(core.getState());
    // Subscribe to core changes so UI and GTM consent updates reactively
    useEffect(() => {
        setState(core.getState());
        return core.subscribe(setState);
    }, [core]);
    return (_jsx(ConsentCtx.Provider, { value: { core, state, strings, dialogId }, children: children }));
}
//# sourceMappingURL=ConsentProvider.js.map